<template>
    <v-row>
      <v-col cols="12">
          <cash-record-card> </cash-record-card> 
      </v-col>
    </v-row>
  </template>
  <script>
  import CashRecordCard from "@/components/report/CashRecordCard";
  
  export default {
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Cash Record",
    },
  
    components: {
        CashRecordCard
    },
  
    data() {
      return {
      };
    },
  };
  </script>